import registerRoutes from './routes';

import miReportServiceFactory from './services/miReport/miReportServiceFactory';

export default function (app) {
    app.factory('miReportServiceFactory', miReportServiceFactory);

    registerRoutes(app);
}



// WEBPACK FOOTER //
// ./Client/app/mireports/index.js